import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Button.module.less";

type ButtonGroupProps = {
  className?: string;
  children?: React.ReactNode;
};

const ButtonGroup: React.FC<ButtonGroupProps> = ({ children, className }) => {
  const classes = cls(
    {
      [styles.buttonGroup]: true,
    },
    className
  );
  return <div className={classes}>{children}</div>;
};

export default ButtonGroup;
